import VerifyIdentity from 'features/otp/challenges/VerifyIdentity/VerifyIdentity';
import React from 'react';

export default function VerifyIdentityScreen() {
  return <VerifyIdentity />;
}
